import {useTranslation} from "next-i18next";
import {FC, useEffect, useRef} from "react";
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/dist/ScrollTrigger';
import Image from "next/image";

import {BoxImageFirstListType, i18translateType,} from "../../@types/types-body";

export const BoxImageFirstImageParagraph: FC<BoxImageFirstListType> = ({
                                                                           namespace, object, image, section,
                                                                       }) => {
    const {t}: i18translateType = useTranslation(namespace);
    const textRef: any = useRef(null);
    const imageRef: any = useRef(null);
    gsap.registerPlugin(ScrollTrigger);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            // Animate paragraphs from left to right

            // Animate image from right to left
            ScrollTrigger.create({
                trigger: imageRef.current, start: 'top bottom-=100', onEnter: () => {
                    // Create a timeline
                    const tl = gsap.timeline();

                    // Add opacity animation to the timeline
                    tl.fromTo(imageRef.current, {opacity: 0}, {opacity: 1, duration: 1});

                    // Add movement animation to the timeline
                    tl.fromTo(imageRef.current, {x: -500}, {x: 0, duration: 3}, "<");
                }, toggleActions: 'play none none none', //once: true
            });
            // Animate image from right to left
            ScrollTrigger.create({
                trigger: textRef.current,
                start: 'top bottom-=100',
                onEnter: () => gsap.fromTo(textRef.current, {x: 500, opacity: 0}, {x: 0, opacity: 1, duration: 3}),
                toggleActions: 'play none none none',
               // once: true
            });
            return () => {
                ScrollTrigger.getAll().forEach((instance) => instance.kill());
            };
        }
        []
    });
    return (<div className="container mx-auto mt-5 flex overflow-hidden">
        <div className="grid grid-cols-12 grid-flow-row-dense lg:grid-flow-col-dense gap-1 content-between">
            <div ref={textRef} className="col-span-12 lg:col-span-6 order-last md:px-12 text-justify ">
                {Object.keys(t(`${object}`, {returnObjects: true})).map((objectValue, index) => (
                    <p className="mb-1 px-4 md:px-0" key={`${object}-${objectValue}-${index}`}>
                        {t(`${object}.${objectValue}`)}
                    </p>))}
            </div>
            <div ref={imageRef}
                 className="col-span-12 lg:col-span-6 min-h-[500px] mb-8 lg:mb-0 relative bg-transparent">
                <Image
                    src={image}
                    alt={section}
                    fill={true}
                    className="h-full bg-transparent"
                />
            </div>
        </div>
    </div>);
};
